import React, { Component, Fragment } from 'react';
import ReactPlayer from 'react-player';
import { connect } from 'react-redux';
import { returnCategories, bgImage } from './../../scripts';
import { breakpoints } from './../../styles/theme.json';

class FilmHoverClip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false
    };
  }
  _mouseOut() {
    this.setState({
      playing: false
    });
  };
  _mouseOver() {
    this.player.seekTo(0);
    this.setState({
      playing: true
    });
  };
  render() {
    return (
      <Fragment>
        {(!this.props.itemData.video_thumb || (this.props.window_width < breakpoints.desktop))
          ? <div className={`img-wrapper-film ${returnCategories(this.props.itemData.nav_categories)}`} style={bgImage(this.props.itemData.image.small)} />
          : <div className={'film-thumb img-wrapper-film'} onMouseOut={() => this._mouseOut()} onMouseOver={() => this._mouseOver()}>
              <div className={'film-thumb__still'} style={bgImage(this.props.itemData.image.small)}/>
              <ReactPlayer
                ref={node => { if (node) this.player = node.player; }}
                url={this.props.itemData.video_thumb}
                className='film-thumb__player'
                width={'100%'}
                height={'100%'}
                muted={true}
                loop={true}
                playing={this.state.playing}
              />
            </div>
        }
      </Fragment>
    );
  }
}

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(FilmHoverClip);



// WEBPACK FOOTER //
// ./src/components/filter-pages/FilmHoverClip.js